// Based on http://stackoverflow.com/a/12042162
// The reason why this is an event listener instead of an iteration over the existing
// links is because we render content dinamically with React.
export default function () {
  $(document).on('click', 'a', function () {
    if (!this.href.match(/^mailto:/) && (this.hostname !== location.hostname)
      && !this.href.match(/^javascript:/) && !this.href.match(/^$/)) {
      // Open on a new tab
      $(this).attr('target', '_blank');

      // Ensure window.opener is null and disable HTTP referer.
      // See https://mathiasbynens.github.io/rel-noopener
      $(this).attr('rel', 'noopener noreferrer');
    }
  });
}
